var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 7.33332L10.6669 3.99999M1.0835 16.9167L3.9038 16.6033C4.24838 16.565 4.42067 16.5459 4.5817 16.4937C4.72457 16.4475 4.86054 16.3821 4.9859 16.2995C5.12721 16.2063 5.24978 16.0837 5.49493 15.8386L16.5002 4.83332C17.4207 3.91285 17.4207 2.42046 16.5002 1.49999C15.5797 0.579513 14.0873 0.579512 13.1669 1.49999L2.1616 12.5052C1.91645 12.7504 1.79388 12.8729 1.70069 13.0142C1.61802 13.1396 1.55268 13.2756 1.50642 13.4185C1.45429 13.5795 1.43515 13.7518 1.39686 14.0964L1.0835 16.9167Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0fda37ec9863c58900e30f0d9e13ad99.svg";
export { ForwardRef as ReactComponent };